<template>
    <div class="d-flex justify-content-center my-5">
      <h1 class="center title">Slider</h1>
    </div>
    <div class="container d-flex justify-content-between  mb-5 ">
      <button type="button" class="btn btn-add" v-on:click="AddAction">Add Slider</button>
    </div>
    <div v-if="!showAddForm && !showUpdateForm" class=" container d-flex justify-content-between flex-wrap" >
      <SliderCard :key="index" v-for=" (slider , index) in this.sliders " :slider=slider  @update="updateAction"  @refresh="getData" />
    </div>
      <AddSlider v-if="showAddForm" @toggle="AddAction" @refresh="getData"  @cancel="getData" />
     <UpdateSlider v-if="showUpdateForm"  :slider="this.toUpdate" @cancel="updateAction" @refresh="getData" />
</template>


<script>
import UpdateSlider from "./components/slider/UpdateSlider.vue";
import SliderCard from "./components/slider/SliderCard.vue";
import AddSlider from "./components/slider/AddSlider.vue";
import axios from "axios";
import APIs from "@/../config";
export default {
    name: "Slider",
    data(){
      return{
        sliders: [] , 
        showAddForm : false, 
        showUpdateForm : false,
        toUpdate : {}

      };
    },
    created(){
        this.getData()
    },
    components:{SliderCard, AddSlider,UpdateSlider},

    methods : {
        getData(){
          axios.get(`${APIs.API_URL}/slider/`)
          .then(res => {
              this.sliders = res.data
          }).catch(error => {
              console.error(error)
          })
          this.showAddForm = this.showUpdateForm = false
        },
        AddAction(){
            this.showAddForm = !this.showAddForm
            if(this.showUpdateForm)
                this.showUpdateForm = !this.showUpdateForm
        },
        updateAction(slider){
          this.showUpdateForm = !this.showUpdateForm
          this.toUpdate = slider
        },
    }
}
</script>




<style scoped>
.center {
    color:white;
}
button{
   background:white;
   color:#A68D5B
}
</style>